import React from 'react';
import '../../../design-system/index.scss';

const Theme = ({ children }) => <>{children}</>;

export default Theme;
